import { render, staticRenderFns } from "./CustomerViewInfoCardPartOne.vue?vue&type=template&id=37345199&scoped=true"
import script from "./CustomerViewInfoCardPartOne.vue?vue&type=script&lang=js"
export * from "./CustomerViewInfoCardPartOne.vue?vue&type=script&lang=js"
import style0 from "./CustomerViewInfoCardPartOne.vue?vue&type=style&index=0&id=37345199&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37345199",
  null
  
)

export default component.exports